<template>
  <svg
    width="7"
    height="7"
    viewBox="0 0 7 7"
  >
    <path d="M5.03753 0.413684C3.78878 -0.0625663 2.88503 0.743684 2.49878 1.19368V0.413684H0.811279V6.54868H2.49878V3.31243C2.48917 2.90225 2.63906 2.50434 2.9169 2.20243C2.99621 2.10908 3.09393 2.03308 3.20394 1.97921C3.31396 1.92533 3.4339 1.89473 3.55628 1.88931C3.69315 1.88668 3.82914 1.91174 3.95608 1.96297C4.08303 2.0142 4.19832 2.09055 4.29503 2.18743C4.50474 2.4066 4.61932 2.69977 4.61378 3.00306V6.54868H6.51878V2.74993C6.51878 2.74993 6.73065 1.04743 5.03753 0.413684Z" fill="white"/>
  </svg>
</template>
